import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import App from './App';


import { allReducer } from './redux/reducers/index'
import './index.css';
import registerServiceWorker from './registerServiceWorker';

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './assets/fonts/fonts_landing.css'


ReactDOM.render(
    <Provider store={allReducer}>
        <App />
    </Provider>
    , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js